export const CONNECTED = 'livescore/CONNECTED';
export const CONNECTION_ERROR = 'livescore/CONNECTION_ERROR';
export const CONNECTION_WARNING = 'livescore/CONNECTION_WARNING';
export const UPDATE_SCORE = 'livescore/UPDATE_SCORE';
export const UPDATE_PERIOD = 'livescore/UPDATE_PERIOD';
export const UPDATE_TIME = 'livescore/UPDATE_TIME';
export const UPDATE_CARDS = 'livescore/UPDATE_CARDS';
export const UPDATE_GOALS = 'livescore/UPDATE_GOALS';
export const UPDATE_STATS = 'livescore/UPDATE_STATS';
export const UPDATE_SUBSCRIPTIONS = 'livescore/UPDATE_SUBSCRIPTIONS';

export const connected = () => ({
  type: CONNECTED
});

export const connectionError = (reason) => ({
  type: CONNECTION_ERROR,
  reason
});

export const connectionWarning = (reason) => ({
  type: CONNECTION_WARNING,
  reason
});

export const updateScore = (eventId, score) => ({
  type: UPDATE_SCORE,
  eventId,
  score
});

export const updatePeriod = (eventId, period) => ({
  type: UPDATE_PERIOD,
  eventId,
  period
});

export const updateTime = (eventId, time) => ({
  type: UPDATE_TIME,
  eventId,
  time
});

export const updateCards = (eventId, cards) => ({
  type: UPDATE_CARDS,
  eventId,
  cards
});

export const updateGoals = (eventId, goals) => ({
  type: UPDATE_GOALS,
  eventId,
  goals
});

export const updateStats = (eventId, { total }) => ({
  type: UPDATE_STATS,
  eventId,
  total
});

export const updateSubscriptions = () => ({
  type: UPDATE_SUBSCRIPTIONS
});
